import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { computed, onBeforeMount, ref, watch } from "vue";
import { getVideoCover } from "@rajesh896/video-thumbnails-generator";



export default /*@__PURE__*/_defineComponent({
  __name: 'VideoViewer',
  props: {
  source: { type: String, required: true },
  controls: { type: Boolean, default: () => false },
},
  emits: ["click", "loaded"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const thumbnail = ref<string>();
const src = ref<string>("");
const isLoaded = ref(false);
onBeforeMount(async () => {
  thumbnail.value = await generateThumbnail(src.value);
});

async function generateThumbnail(blobUrl: string): Promise<undefined | string> {
  console.log("generate thumbnail!");
  let thumbnail = undefined;
  try {
    console.log("getVideoCover", blobUrl);
    thumbnail = await getVideoCover(blobUrl);
  } catch (e) {
    console.log("error: ", e);
  }
  return thumbnail;
}

watch(
  computed(() => props.source),
  async (newVal, oldVal) => {
    isLoaded.value = false;
    src.value = props.source;
    thumbnail.value = await generateThumbnail(src.value);
  },
);

function loaded() {
  console.log("loaded from video viewer");
  //spinnerManager.unregisterTask("loading media");
  isLoaded.value = true;
  emit("loaded");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click', __props.source))),
    class: "maxSize"
  }, [
    _createElementVNode("video", {
      src: __props.source,
      controls: "",
      playsinline: "",
      "webkit-playsinline": "",
      onLoadeddata: loaded,
      class: "maxSize"
    }, null, 40, _hoisted_1)
  ]))
}
}

})